import { FC } from 'react';
import Close from '../../assets/close.png';
import ConfirmButton from '../../component/button/button';
import { Trans } from 'react-i18next';
import { ConfirmationModalProps } from './confirmationModal.type';
import ButtonSpinner from '../../assets/buttonLoading/buttonLoading';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'confirmation-modal';

const ConfirmationModal: FC<ConfirmationModalProps> = (props) => {
  if (!props.isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(192,193,199,0.4)]"
      {...getIdAttributes(idPrefix, 'overlay')}
    >
      <div
        className={`relative w-full max-w-sm px-12 bg-white rounded-lg shadow-lg ${
          props.showConfirmButton ? 'py-14' : 'p-16'
        }`}
        {...getIdAttributes(idPrefix, 'container')}
      >
        <img
          onClick={props.onClose}
          src={Close}
          alt="Close Layout"
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 h-4 w-4"
          {...getIdAttributes(idPrefix, 'close-button')}
        />

        <p
          className="text-center text-sm text-gray-700"
          {...getIdAttributes(idPrefix, 'message')}
        >
          {props.message}
        </p>

        {props.showConfirmButton && (
          <div
            className="mt-6 flex justify-center"
            {...getIdAttributes(idPrefix, 'button-container')}
          >
            <ConfirmButton
              className="px-8 py-2 rounded-full text-sm bg-THEME_COLOR hover:bg-THEME_HOVER_COLOR"
              onClick={props.onConfirm}
              data-testid={`${idPrefix}-confirm-button`}
            >
              {props.isLoading ? (
                <ButtonSpinner />
              ) : (
                <Trans i18nKey="userManagement.confirm" />
              )}
            </ConfirmButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationModal;
